import { render, staticRenderFns } from "./siterecord.vue?vue&type=template&id=55705169"
import script from "./siterecord.vue?vue&type=script&lang=js"
export * from "./siterecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports